export default __webpack_public_path__ + "static/media/feature-3.f0b6e53d.svg";